import { render, staticRenderFns } from "./packageAgent.vue?vue&type=template&id=0fcf98ef&scoped=true"
import script from "./packageAgent.vue?vue&type=script&lang=js"
export * from "./packageAgent.vue?vue&type=script&lang=js"
import style0 from "./packageAgent.vue?vue&type=style&index=0&id=0fcf98ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf98ef",
  null
  
)

export default component.exports